define('TavanoTeamStaging.Feedback', [
  'TavanoTeamStaging.Feedback.Form.View'
], function (
  FeedbackFormView
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var PageType = container.getComponent('PageType');

      PageType.registerPageType({
        name: 'feedback',
        routes: ['feedback'],
        view: FeedbackFormView,
        defaultTemplate: {
          name: 'tavanoteamstaging_feedback_form.tpl',
          displayName: 'Feedback'
        }
      });
    },
  };
});
